// ------------------------------------
// Bônus (Carrosel)
// ------------------------------------

const $bonusCarrosel = $('#carrosel-bonus');

bonusInitSlick();

// Desabilita o plugin de carrosel
function bonusDestroySlick() {
  if ($bonusCarrosel.hasClass('slick-slider')) {
    $bonusCarrosel.slick('unslick');
  }
}

// Reinicia o carrosel ao alterar o tamanho da tela
/* $(window).on('resize orientationchange', function () {
  if ($(window).width() > 768) {
    bonusInitSlick();
  } 
}); */

// Aplica o plugin de carrosel
function bonusInitSlick() {
  if (!$bonusCarrosel.hasClass('slick-initialized')) {
    let settingMb = 'unslick';
    $bonusCarrosel.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      autoplay: false,
      adaptiveHeight: true,
      // Responsivo
      responsive: [
        // Tablet
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 3,
          },
        },
        // Mobile
        {
          breakpoint: 768,
          settings: settingMb,
        },
      ],
    });
  }
}

slickReinitLazy($bonusCarrosel, bonusInitSlick, bonusDestroySlick);
